"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableStyled = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const components_1 = require("@veeam/components");
exports.TableStyled = styled_components_1.default.table.attrs({
    cellPadding: 0,
    cellSpacing: 0,
}) `
  width: 100%;
  table-layout: fixed;
  font: ${components_1.BASE_FONT};
  color: ${({ theme }) => theme.fonts.colors.primary};
  border: 0;
  border-collapse: collapse;
`;
exports.TableStyled.displayName = 'TableStyled';
//# sourceMappingURL=TableStyled.js.map